module.exports = __webpack_public_path__ + "img/plus.7f9b5c15.svg";